import * as React from 'react';

function Logo(props) {
  return (
    <svg width={200} height={52} fill="none" {...props}>
      <path
        d="M0 50.687h33.982l2.141-11.994h-19.06L23.843 0H8.924L0 50.687zM76.204 50.687h14.278L81.415 0H63.711L36.797 50.687H52.36l4.997-10.352h17.49l1.357 10.352zM62.212 30.341l5.282-10.994c1.357-2.785 2.57-5.212 3.855-8.995h.143c0 3.783.286 6.924.571 8.995l1.428 10.994h-11.28zM100.166 0l-5.068 28.984c-3.141 18.062 8.424 22.917 20.417 22.917 16.92 0 22.345-9.638 23.631-16.991L145.285 0h-14.92l-5.64 32.197c-.643 3.712-2.856 7.853-8.424 7.853-3.784 0-7.925-1.928-6.568-9.566L115.087 0h-14.921zM156.738 50.687H174.3L200 0h-16.634l-13.207 30.127c-1.356 3.07-2.142 4.997-2.713 7.067h-.285c.142-2.07.071-3.998-.215-7.067L164.376 0h-15.491l7.853 50.687z"
        fill="#fff"
      />
    </svg>
  );
}

export default Logo;
